import React from 'react'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
const FullscreenEnter = ({ color, ...rest }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 160 160' {...rest}>
    <g id='Layer_2_1_' style={{ display: 'none' }}>
      <rect x='-100' y='-100' style={{ display: 'inline' }} width='360' height='360' />
    </g>
    <polyline fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' points='69.06,91.85 16.94,147.02 13.89,150.27 11.14,153.17 ' />
    <polyline fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' points='54,154 13.74,154 11,154 11,147.9 11,108 ' />
    <line fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' x1='16.94' y1='147.02' x2='69.06' y2='91.85' />
    <polyline fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' points='90.62,67.28 142.74,12.1 145.79,8.86 148.53,6 ' />
    <polyline fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' points='106,6 146.26,6 149,6 149,12.1 149,52 ' />
    <line fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' x1='142.74' y1='12.1' x2='90.62' y2='67.28' />
    <polyline fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' points='69.06,91.85 16.94,147.02 13.89,150.27 11.14,153.17 ' />
    <line fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' x1='16.94' y1='147.02' x2='69.06' y2='91.85' />
    <polyline fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' points='90.62,67.28 142.74,12.1 145.79,8.86 148.53,6 ' />
    <polyline fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' points='106,6 146.26,6 149,6 149,12.1 149,52 ' />
    <line fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' x1='142.74' y1='12.1' x2='90.62' y2='67.28' />
  </svg>
)
/* --------------------------------------------- */
FullscreenEnter.propTypes = {
  /** Color of icon. */
  color: PropTypes.string,
  /** Icon css styles. */
  style: PropTypes.object
}
/* --------------------------------------------- */
FullscreenEnter.defaultProps = {
  color: 'transparent',
  style: {
    width: 35,
    height: 35
  }
}
/* --------------------------------------------- */
export default FullscreenEnter
/* --------------------------------------------- */
